<template>
  <div v-show="showVideo" class="videoContainer">
    <div @click="exit()" class="close">
      <simpleClose />
    </div>
    <video
      id="RDS-SimplePlayer"
      class="video-js video-js-vr vjs-default-skin"
      controls=""
      playsinline=""
      width="640"
      height="300"
    ></video>
    <transition
      enterActiveClass="animated fadeIn"
      leaveActiveClass="animated fadeOut"
    >
      <reaction-stripe
        v-show="rbv"
        :player="player"
        :player-instance="player"
        :player-state="true"
        :customFS="true"
      />
    </transition>
  </div>
</template>
<script>

import simpleClose from '@/components/glyphs/SimpleClose.vue';
import {
  mapMutations,
  mapState,
} from 'vuex';
import ReactionStripe from '@/components/ReactionStripe.vue';

export default {
  props: ['url'],
  name: 'Player',
  components: {
    simpleClose,
    ReactionStripe,
  },
  data() {
    return {
      showVideo: false,
      player: false,
      rbv: true,
      interval: false,
    };
  },
  mounted() {
    const env = 'special';
    const reactionStripeConfig = {
      ...this.reactionStripeConfig,
      ADS_URL: this.conf[env].ADS_URL,
      appid: this.conf[env].appid,
      service: this.conf[env].service,
      host: this.conf[env].host,
      BASE_GROUP_PHOTO_URL: this.conf[env].BASE_GROUP_PHOTO_URL,
      BASE_SHARE_URL: `${this.conf[env].BASE_SHARE_URL + this.conf[env].appid}/${this.$t('lang')}?id=`,
      TWITTER_TEXT: encodeURI(this.$t('TWITTER_TEXT')),
    };
    window.start(this.token, reactionStripeConfig);
    window.initBar();
    this.play(this.url);
    this.interval = setInterval(() => {
      this.rbv = this.player.userActive();
    }, 250);
  },
  methods: {
    ...mapMutations([
      'setRdsPlayer',
      'setRdsPlayer360',
      'setRdsPlayerShow',
      'setRdsPlayer360Show',
    ]),
    exit() {
      this.showVideo = false;
      this.player.pause();
      this.player.dispose();
      this.$emit('exit');
    },
    play(url) {
      // eslint-disable-next-line no-multi-assign
      this.player = window.videojs('RDS-SimplePlayer');
      this.player.src({
        type: 'application/x-mpegURL',
        src: url,
      });
      this.player.play();
      this.showVideo = true;
    },
  },
  computed: {
    ...mapState([
      'rdsPlayer',
      'rdsPlayer360',
      'rdsPlayerShow',
      'rdsPlayer360Show',
    ]),
  },
};
</script>

<style scoped>
  .videoContainer {
    position: relative;
  }
  .close {
    width: 50px;
    height: 50px;
    position: absolute;
    z-index: 5;
    top: 20px;
    left: 20px;
  }
</style>
